@if(!loading){
@if(user) {
<div class="tw-flex tw-gap-2 tw-items-center">
  @if(user._impersonated){
  <button mat-flat-button class="btn-warning" (click)="unImpersonate()">
    <mat-icon>key</mat-icon>
    <span>Exit Account</span>
  </button>
  } @else if(user._accounts?.length){
  <mat-select name="accounts" (selectionChange)="impersonate($event.value)" class="tw-min-w-24"
    placeholder="Switch Account">
    @for(account of user._accounts;track $index)
    {<mat-option [value]="account.accountId">{{account.name}}</mat-option>}
  </mat-select>
  }
  @if(hasInvitations){
  <a mat-icon-button routerLink="/account/workspaces-invitations" title="You have workspace invitations">
    <i class="pi pi-briefcase text-warning tw-animate-pulse"></i>
  </a>
  }
  <div [matTooltip]="softphoneLauncherTooltip">
    <button
      mat-icon-button
      type="button"
      class="surface-opacity-darker tw-relative tw-rounded-full"
      [class.btn-success]="softphoneLauncherTone === 'success'"
      [class.btn-warning]="softphoneLauncherTone === 'warning'"
      [class.btn-danger]="softphoneLauncherTone === 'danger'"
      [class.btn-secondary]="softphoneLauncherTone === 'secondary'"
      [class.tw-opacity-60]="softphoneLauncherDisabled"
      [class.tw-cursor-default]="softphoneLauncherDisabled"
      aria-label="Softphone"
      [attr.aria-disabled]="softphoneLauncherDisabled"
      (click)="openSoftphonePanel()">
      <mat-icon>phone</mat-icon>
      @if(softphoneLauncherNeedsAttention) {
      <span aria-hidden="true"
        class="surface-danger tw-absolute tw-right-0 tw-top-0 tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-rounded-full tw-text-xs tw-font-bold tw-animate-pulse">!</span>
      }
    </button>
  </div>
  <app-live-transfer-position />
  <div class="tw-flex tw-gap-2 tw-items-center tw-cursor-pointer" [matMenuTriggerFor]="userMenu">
    <app-user-avatar [user]="user" />
  </div>
  <mat-menu #userMenu="matMenu">
    <a mat-menu-item routerLink="/profile">
      <mat-icon>person</mat-icon>
      <span>My Profile</span>
    </a>
    @if(pulseLogin.isAvailable()){
    <div [matTooltip]="user._impersonated ? 'Exit impersonation to open Pulse.' : ''">
      <button mat-menu-item type="button" [disabled]="user._impersonated" (click)="pulseLogin.open()"
        aria-label="Open Pulse in a new tab">
        <mat-icon>open_in_new</mat-icon>
        <span>Open Pulse</span>
      </button>
    </div>
    }
    @if(user._metadata?.billing?.customerId){
    <a mat-menu-item routerLink="/account">
      <mat-icon>settings</mat-icon>
      <span>Account Settings</span>
    </a>
    }
    @if(user.resellerConfig?.isApproved){
    <a mat-menu-item routerLink="/reseller">
      <mat-icon>settings</mat-icon>
      <span>Reseller Settings</span>
    </a>
    }
    @if(user.affiliateConfig?.isApproved){
    <a mat-menu-item routerLink="/affiliate">
      <mat-icon>settings</mat-icon>
      <span>Affiliate Settings</span>
    </a>
    }
    @if(user.roles?.includes('super-admin') || user.roles?.includes('operator')){
    <a mat-menu-item routerLink="/admin">
      <mat-icon>shield</mat-icon>
      <span>Admin Area</span>
    </a>
    }
    @if(user._metadata?.billing?.customerId){
    <a mat-menu-item routerLink="/operators">
      <mat-icon>groups</mat-icon>
      <span>Operators</span>
    </a>
    }
    @if(hasWorkspaces){
    <a mat-menu-item routerLink="/account/workspaces-invitations">
      <mat-icon>business_center</mat-icon>
      <span>Workspaces</span>
    </a>
    }
    <mat-divider></mat-divider>
    <div mat-menu-item class="hover:!tw-bg-inherit" (click)="$event.stopPropagation()">
      <mat-icon>palette</mat-icon>
      <span>Theme</span>
    </div>
    <mat-button-toggle-group [value]="theme()" (change)="setTheme($event.value)" name="theme" class="tw-mx-2"
      (click)="$event.stopPropagation();">
      @for(option of themeOptions; track option.value) {
      <mat-button-toggle [value]="option.value" [matTooltip]="option.label" [attr.aria-label]="option.label">
        <mat-icon>{{option.icon}}</mat-icon>
      </mat-button-toggle>
      }
    </mat-button-toggle-group>

    <mat-divider></mat-divider>
    <button mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Logout</span>
    </button>
  </mat-menu>
</div>
} @else {
<a mat-flat-button routerLink="/login" class="btn-warning">Login or Sign Up</a>
}
}
